import { sortBy } from 'lodash';
import { ReactElement, useMemo } from 'react';
import { useGetApplicationDefaultParameterSetTags } from '../../../../shared/hook/application-default-parameter-set.hooks';
import { ApplicationDefaultParameterSetFormTags } from '../../../../shared/model/flow.types';
import { BeaconCuttingData } from '../../model/beacon-cutting-data';
import { CutApplicationTagPicker } from './cut-application-tag-picker';

interface CutApplicationSettingsTagsProps {
  process: BeaconCuttingData.CutProcessValue | undefined;
  parameterSetFormTags?: ApplicationDefaultParameterSetFormTags;
  readOnly?: boolean;
  excludeTags?: string[];
}

const CutApplicationSettingsTags = (
  props: CutApplicationSettingsTagsProps
): ReactElement => {
  const { process, parameterSetFormTags, excludeTags, readOnly } = props;

  const parameterSetTags = useGetApplicationDefaultParameterSetTags();

  const tagSelects = useMemo(() => {
    return sortBy(Object.entries(parameterSetTags), ([k, v]) => [
      v.order ?? Number.POSITIVE_INFINITY,
      k,
    ])
      .filter((tag) => {
        return !excludeTags?.map((t) => t.toString()).includes(tag[0]);
      })
      .map(([tagName, tag]) => {
        return (
          <CutApplicationTagPicker
            key={tagName}
            process={process}
            tagName={tagName}
            tag={tag}
            tags={parameterSetFormTags}
            readOnly={readOnly}
          />
        );
      });
  }, [excludeTags, process, readOnly, parameterSetFormTags, parameterSetTags]);

  return <>{tagSelects}</>;
};

export { CutApplicationSettingsTags };
